import { fromJS } from 'immutable';
import { compose } from 'redux';
import * as constants from './constants';

const COURSEWARE_PATH = 'courseware';

const initialState = fromJS({
  courseware: {},
});

const setCoursewareMetaInfoValue = (state, elementId, key, value) => (
  state.setIn([COURSEWARE_PATH, elementId, 'meta', key, 'value'], value));

const setCoursewareMetaInfoIsLoading = (state, elementId, key, isLoading) => (
  state.setIn([COURSEWARE_PATH, elementId, 'meta', key, 'isLoading'], isLoading));

const setCoursewareMetaInfoError = (state, elementId, key, error) => (
  state.setIn([COURSEWARE_PATH, elementId, 'meta', key, 'error'], error));

const setCoursewareMetaInfoIsSetting = (state, elementId, key, isSetting) => (
  state.setIn([COURSEWARE_PATH, elementId, 'meta', key, 'isSetting'], isSetting));

const setCoursewareMetaInfoSetError = (state, elementId, key, setError) => (
  state.setIn([COURSEWARE_PATH, elementId, 'meta', key, 'setError'], setError));

function workspaceCoursewareReducer(state = initialState, action) {
  switch (action.type) {
    // Get
    case constants.COURSEWARE_META_INFO_GET_REQUEST:
      return compose(
        (intermediateState) => setCoursewareMetaInfoIsLoading(intermediateState, action.elementId, action.key, true),
        (intermediateState) => setCoursewareMetaInfoError(intermediateState, action.elementId, action.key, false),
      )(state);

    case constants.COURSEWARE_META_INFO_GET_SUCCESS:
      return compose(
        (intermediateState) => setCoursewareMetaInfoIsLoading(intermediateState, action.elementId, action.key, false),
        (intermediateState) => setCoursewareMetaInfoValue(intermediateState, action.elementId, action.key, action.value),
      )(state);

    case constants.COURSEWARE_META_INFO_GET_ERROR:
      return setCoursewareMetaInfoError(state, action.elementId, action.key, true);

      // Set
    case constants.COURSEWARE_META_INFO_SET_REQUEST:
      return compose(
        (intermediateState) => setCoursewareMetaInfoIsSetting(intermediateState, action.elementId, action.key, true),
        (intermediateState) => setCoursewareMetaInfoSetError(intermediateState, action.elementId, action.key, false),
      )(state);

    case constants.COURSEWARE_META_INFO_SET_SUCCESS:
      return compose(
        (intermediateState) => setCoursewareMetaInfoIsSetting(intermediateState, action.elementId, action.key, false),
        (intermediateState) => setCoursewareMetaInfoValue(intermediateState, action.elementId, action.key, action.value),
      )(state);

    case constants.COURSEWARE_META_INFO_SET_ERROR:
      return setCoursewareMetaInfoSetError(state, action.elementId, action.key, true);

    default:
      return state;
  }
}

export default workspaceCoursewareReducer;
